import { useState } from "react";
import LoanCard from "../../shared/LoanCard";
import {
  CheckCircle2,
  Circle,
  CircleDashed,
  Clock,
  FilePlus,
  FileSearch,
  HelpCircle,
  Landmark,
  Loader,
  LucideUpload,
  Plus,
  Search,
  Sigma,
  SortAsc,
  Wallet,
  XCircle,
} from "lucide-react";
import Pagination from "../../shared/Pagination";
import { useNavigate } from "react-router-dom";
import LoanAmount from "../../components/loan-application/LoanAmount";
import BioInformation from "../../components/loan-application/BioInformation";
import PersonalInformation from "../../components/loan-application/PersonalInformation";
import NextOfKin from "../../components/loan-application/NextOfKin";
import IncomeDetails from "../../components/loan-application/IncomeDetails";
import BusinessLocation from "../../components/loan-application/BusinessLocation";
import ResidenceLocation from "../../components/loan-application/ResidenceLocation";
import BorrowerChattels from "../../components/loan-application/BorrowerChattels";
import AddChattel from "../../components/loan-application/AddChattel";
import Guarantors from "../../components/loan-application/Guarantors";
import AddGuarantor from "../../components/loan-application/AddGuarantor";
import AddGuarantorChattel from "../../components/loan-application/AddGuarantorChattel";
import Finish from "../../components/loan-application/Finish";
import Success from "../../components/loan-application/Success";
import Fail from "../../components/loan-application/Fail";
import LoanApplicationSkeleton from "../../skeletons/LoanApplicationSkeleton";
import { useFormatAmount } from "../../hooks/useFormatAmount";
import { useFormattedDate } from "../../hooks/useFormattedDate";
import {
  addGuarantorChattel,
  addLoanApplicationDocument,
  createApplicationGuarantors,
  createLoanApplication,
  getLoanApplications,
  getLoanApplicationStatistics,
  updateApplicationStage,
  updateLoanApplication,
} from "../../sdk/applications/applications";
import { useError } from "../../context/ErrorProvider";
import { useMutation, useQuery } from "react-query";
import {
  addBankStatement,
  addBorrowerChattel,
  addIncomeDetails,
  addMpesaStatement,
  addNextOfKin,
  addPayslips,
  createBorrower,
  updateBorrower,
  updateBorrowerBusinessDetails,
  updateBorrowerResidenceDetails,
} from "../../sdk/borrower/borrower";
import useAuth from "../../hooks/useAuth";
import { useBorrower } from "../../context/BorrowerContext";
import { useLoanApplication } from "../../context/LoanApplicationContext";
import Filter from "../../components/filter/Filter";
import LoanDocuments from "../../components/loan-application/LoanDocuments";
import AddLoanDocument from "../../components/loan-application/AddLoanDocument";
import Loading from "../../shared/Loading";
import MpesaStatement from "../../components/loan-application/MpesaStatement";
import BankStatement from "../../components/loan-application/BankSatement";
import Payslips from "../../components/loan-application/Payslips";
import { Button, Dropdown } from "antd";
import {
  exportAllSelectedLoanApplications,
  exportLoanApplications,
} from "../../sdk/exports/export";
import { downloadExportFile } from "../../utils/export";
import { hasPermission } from "../../utils/permissions";

const LoanApplications = () => {
  const items = [
    {
      key: "csv",
      label: "Export as CSV",
      onClick: () => exportAllLoanApplications({ format: "csv" }),
    },
    {
      key: "pdf",
      label: "Export as PDF",
      onClick: () => exportAllLoanApplications({ format: "pdf" }),
    },
  ];

  const selectedItems = [
    {
      key: "csv",
      label: "Export as CSV",
      onClick: () => exportSelectedLoanApplications({ format: "csv" }),
    },
    {
      key: "pdf",
      label: "Export as PDF",
      onClick: () => exportSelectedLoanApplications({ format: "pdf" }),
    },
  ];
  const [openLoanAmount, setOpenLoanAmount] = useState(false);
  const [openBioInformation, setOpenBioInformation] = useState(false);
  const [openPersonalInformation, setOpenPersonalInformation] = useState(false);
  const [openKinInformation, setOpenKinInformation] = useState(false);
  const [openIncomeInformation, setOpenIncomeInformation] = useState(false);
  const [openBusinessLocation, setOpenBusinessLocation] = useState(false);
  const [openResidenceLocation, setOpenResidenceLocation] = useState(false);
  const [openChattels, setOpenChattels] = useState(false);
  const [openFinish, setOpenFinish] = useState(false);
  const [openGuarantorInformation, setOpenGuarantorInformation] =
    useState(false);
  const [openAddChattel, setOpenAddChattel] = useState(false);
  const [openDocumentSuccess, setOpenDocumentSuccess] = useState(false);
  const [openDocumentFail, setOpenDocumentFail] = useState(false);
  const [openAddGuarantorChattel, setOpenAddGuarantorChattel] = useState(false);
  const [openAddGuarantor, setOpenAddGuarantor] = useState(false);
  const [openLoanDocuments, setOpenLoanDocuments] = useState(false);
  const [openAddDocument, setOpenAddDocument] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [modalKey, setModalKey] = useState(0);
  const handlePageChange = (page) => {
    setPage(page);
  };
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();
  const [selectedFrontIdFile, setSelectedFrontIdFile] = useState(null);
  const [selectedBackIdFile, setSelectedBackIdFile] = useState(null);
  const formatAmount = useFormatAmount();
  const formattedDate = useFormattedDate();
  const { showError } = useError();
  const [loanApplications, setLoanApplications] = useState([]);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [fromDate, setFromDate] = useState(
    new Date("2023-11-23").toISOString(),
  );
  const [toDate, setToDate] = useState(new Date().toISOString());
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [selectedLoanOfficer, setSelectedLoanOfficer] = useState("");
  const [selectedLoanProduct, setSelectedLoanProduct] = useState("");
  const [minLoanAmount, setMinLoanAmount] = useState("");
  const [maxLoanAmount, setMaxLoanAmount] = useState("");
  const { loanApplication, setLoanApplication } = useLoanApplication();

  const [totalItems, setTotalItems] = useState(0);
  const [openLoanFilter, setOpenLoanFilter] = useState(false);
  const [selectedGuarantor, setSelectedGuarantor] = useState("");
  const [loanDetails, setLoanDetails] = useState({
    loanProduct: "",
    loanAmount: "",
    loanDuration: "",
    purpose: "",
  });
  const [borrowerInfo, setBorrowerInfo] = useState({
    username: "",
    maritalStatus: "",
    phoneNumber: "",
    altPhoneNumber: "",
    email: "",
    dependants: "",
    postalAddress: "",
  });

  const [idDetails, setIdDetails] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    identification: "",
    identification_type: "National ID",
    dateOfBirth: "",
    country_of_residence: "Kenya",
    citizenship: "Kenyan",
    gender: "",
    id_back_image: "",
    id_front_image: "",
  });

  const [kinDetails, setKinDetails] = useState({
    name: "",
    dateOfBirth: "",
    relationship: "",
    phoneNumber: "",
    location: "",
  });

  const [incomeDetails, setIncomeDetails] = useState({
    customerId: "",
    sourceOfIncome: "",
    yearsOfOperation: "",
    typeOfBusiness: "",
    businessOwnership: "",
    levelOfStability: "",
    risksAssociated: "",
    strengthOfBusiness: "",
    mpesaStatementUrl: "",
    mpesaCode: "",
    businessLicense: "",
    employerName: "",
    monthlyIncome: "",
    durationAtEmployer: "",
    kraPin: "",
    businessName: "",
    statementType: "",
    bankStatementType: "",
    bankStatementUrl: "",
    bankStatementCode: "",
    bankName: "",
    bankStatementPeriod: "",
  });

  const [openMpesaStatement, setOpenMpesaStatement] = useState(false);
  const [openBankStatement, setOpenBankStatement] = useState(false);
  const [openPayslips, setOpenPayslips] = useState(false);

  const toggleMpesaStatement = () => {
    setOpenMpesaStatement(true);
  };
  const closeMpesaStatement = () => {
    setOpenMpesaStatement(false);
  };

  const { mutate: addMyMpesaStatement, isLoading: loadingMpesaStatement } =
    useMutation({
      mutationKey: ["add mpesa statement"],
      mutationFn: () =>
        addMpesaStatement(
          borrower?.id,
          incomeDetails?.mpesaCode,
          incomeDetails?.mpesaStatementUrl,
        ),
      onSuccess: () => {
        closeMpesaStatement();
        toggleBankStatement();
      },
      onError: (errors) => {
        showError(errors?.response?.data?.message || errors.message);
      },
    });

  const handleUpdateMpesaStatement = () => {
    setActiveIndex(3);
    addMyMpesaStatement();
  };

  const toggleBankStatement = () => {
    setOpenBankStatement(true);
  };
  const closeBankStatement = () => {
    setOpenBankStatement(false);
  };

  const { mutate: addMyBankStatement, isLoading: loadingBankStatement } =
    useMutation({
      mutationKey: ["add bank statement"],
      mutationFn: () =>
        addBankStatement(
          borrower?.id,
          incomeDetails?.bankName,
          incomeDetails?.bankStatementUrl,
          incomeDetails?.bankStatementCode,
          incomeDetails?.bankStatementPeriod,
        ),
      onSuccess: () => {
        closeBankStatement();
        togglePayslips();
      },
      onError: (errors) => {
        showError(errors?.response?.data?.message || errors.message);
      },
    });

  const handleAddBankStatement = () => {
    setActiveIndex(3);
    addMyBankStatement();
  };

  const togglePayslips = () => {
    setOpenPayslips(true);
  };
  const closePayslips = () => {
    setOpenPayslips(false);
  };

  const [payslips, setPayslips] = useState([]);

  const { mutate: addIncomePayslips, isLoading: loadingPayslips } = useMutation(
    {
      mutationKey: ["add payslips"],
      mutationFn: () => addPayslips(borrower?.id, payslips),
      onSuccess: () => {
        closePayslips();
        toggleBusinessLocation();
      },
      onError: (errors) => {
        showError(errors?.response?.data?.message || errors.message);
      },
    },
  );

  const handleAddPayslips = () => {
    setActiveIndex(3);
    addIncomePayslips();
  };

  const [borrowerBusinessInfo, setBorrowerBusinessInfo] = useState({
    businessName: "",
    businessCounty: "",
    businessSubCounty: "",
    businessWard: "",
    businessVillage: "",
    businessLatitude: "",
    businessLongitude: "",
    businessPhysicalAddress: "",
    businessLocationDescription: "",
    businessImageUrl: "",
    businessPostalAddress: "",
  });

  const [borrowerResidenceInfo, setBorrowerResidenceInfo] = useState({
    residenceCounty: "",
    residenceSubCounty: "",
    residenceWard: "",
    residenceVillage: "",
    residenceLatitude: "",
    residenceLongitude: "",
    residencePhysicalAddress: "",
    residenceLocationDescription: "",
    residenceImageUrl: "",
  });

  const [borrowerChattel, setBorrowerChattel] = useState({
    name: "",
    location: "",
    value: 0,
    fileUrl: "",
    description: "",
    condition: "Good",
    images: null,
  });

  const [guarantorChattel, setGuarantorChattel] = useState({
    name: "",
    location: "",
    value: 0,
    fileUrl: "",
    description: "",
    condition: "Good",
    images: null,
  });

  const [guarantor, setGuarantor] = useState({
    guarantorName: "",
    guarantorPhone: "",
    guarantorEmail: "",
    residenceCounty: "",
    residenceSubCounty: "",
    residenceWard: "",
    residenceVillage: "",
    residenceLatitude: "",
    residenceLongitude: "",
    signatureUrl: "",
    guaranteeAmount: "",
    status: "",
    reason: "",
    guarantorPhoto: "",
    guarantorBusinessPhoto: "",
    residenceLocation: "",
  });

  const [loanDocuments, setLoanDocuments] = useState([]);

  const toggleLoanDocuments = () => {
    setOpenLoanDocuments(true);
  };

  const closeLoanDocuments = () => {
    setOpenLoanDocuments(false);
  };

  const toggleAddDocument = () => {
    setOpenAddDocument(true);
  };

  const closeAddDocument = () => {
    setOpenAddDocument(false);
  };

  const handleOpenAddDocument = () => {
    closeLoanDocuments();
    toggleAddDocument();
  };

  const { mutate: addLoanDocumentMutate, isLoading: loadingLoanDocument } =
    useMutation({
      mutationKey: ["Add loan document"],
      mutationFn: () =>
        addLoanApplicationDocument(loanApplication?.id, loanDocuments),
      onSuccess: () => {
        setLoanDocuments([]);
        closeAddDocument();
        toggleLoanDocuments();
      },
      onError: (errors) => {
        showError(errors?.response?.data?.message || errors.message);
      },
    });

  const handleSubmitLoanDocument = () => {
    addLoanDocumentMutate();
  };

  const [errors, setErrors] = useState({});
  const { auth } = useAuth();
  const { borrower, setBorrower } = useBorrower();

  const validateFields = () => {
    const newErrors = {};

    if (!borrowerInfo.username) {
      newErrors.username = "Please enter a valid username.";
    }

    if (!borrowerInfo.email || !/\S+@\S+\.\S+/.test(borrowerInfo.email)) {
      newErrors.email = "Please enter a valid email.";
    }

    if (
      !borrowerInfo.phoneNumber ||
      !/^\d{10,15}$/.test(borrowerInfo.phoneNumber)
    ) {
      newErrors.phoneNumber = "Enter a valid phone number.";
    }
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const { mutate: borrowerMutate, isLoading: isLoadingBorrower } = useMutation({
    mutationKey: ["create borrower"],
    mutationFn: () =>
      createBorrower(
        borrowerInfo.altPhoneNumber,
        borrowerInfo.email,
        borrowerInfo.phoneNumber,
        borrowerInfo.maritalStatus,
        borrowerInfo.dependants,
        borrowerInfo.username,
        borrowerInfo.postalAddress,
      ),
    onSuccess: (data) => {
      setBorrower(data);
      applicationMutate(data?.id);
    },
    onError: (errors) => {
      showError(errors?.response?.data?.message || errors.message);
    },
  });

  const { mutate: applicationMutate } = useMutation({
    mutationKey: ["application"],
    mutationFn: (id) =>
      createLoanApplication(
        id,
        auth?.user?.id,
        loanDetails.loanProduct,
        loanDetails.loanAmount,
        loanDetails.loanDuration,
        loanDetails?.purpose,
      ),
    onSuccess: (data) => {
      setLoanApplication(data);
      handleCollectKinInformation();
    },
    onError: (errors) => {
      showError(errors?.response?.data?.message || errors.message);
    },
  });

  const handleSubmitBorrowerInfo = () => {
    if (validateFields()) {
      borrowerMutate();
    }
  };

  const {
    mutate: updateApplicationStageMutate,
    isLoading: loadingApplicationStage,
  } = useMutation({
    mutationKey: ["update application stage"],
    mutationFn: (stage) => updateApplicationStage(loanApplication?.id, stage),
    onSuccess: () => {},
    onError: (errors) => {
      showError(errors?.response?.data?.message || errors.message);
    },
  });

  const { mutate: updateMutate, isLoading: isLoadingBioInformation } =
    useMutation({
      mutationKey: ["update borrower"],
      mutationFn: () =>
        updateBorrower(
          borrower?.id,
          idDetails.firstName,
          idDetails.middleName,
          idDetails.lastName,
          idDetails.identification,
          idDetails.identification_type,
          idDetails.country_of_residence,
          idDetails.dateOfBirth,
          idDetails.citizenship,
          idDetails.gender,
          idDetails.id_back_image,
          idDetails.id_front_image,
        ),
      onSuccess: () => {
        handleCollectPersonalInformation();
      },
      onError: (errors) => {
        showError(errors?.response?.data?.message || errors.message);
      },
    });

  const handleSubmitBioInformation = async () => {
    updateMutate();
  };

  const { mutate: kinMutate, isLoading: isLoadingKin } = useMutation({
    mutationKey: ["nextOfKin"],
    mutationFn: () =>
      addNextOfKin(
        borrower?.id,
        kinDetails.name,
        kinDetails.dateOfBirth,
        kinDetails.relationship,
        kinDetails.phoneNumber,
        kinDetails.location,
      ),
    onSuccess: () => {
      updateApplicationStageMutate("personal-details");
      handleCollectIncomeInformation();
    },
    onError: (errors) => {
      showError(errors?.response?.data?.message || errors.message);
    },
  });

  const handleSubmitKinInformation = () => {
    // validate kin
    kinMutate();
  };

  const { mutate: updateIncomeMutate, isLoading: isLoadingIncome } =
    useMutation({
      mutationKey: ["update income"],
      mutationFn: () =>
        addIncomeDetails(
          borrower?.id,
          incomeDetails.sourceOfIncome,
          incomeDetails.yearsOfOperation,
          incomeDetails.typeOfBusiness,
          incomeDetails.businessOwnership,
          incomeDetails.levelOfStability,
          incomeDetails.risksAssociated,
          incomeDetails.strengthOfBusiness,
          incomeDetails?.businessLicense,
          incomeDetails?.employerName,
          incomeDetails?.monthlyIncome,
          incomeDetails?.durationAtEmployer,
          incomeDetails?.kraPin,
          incomeDetails?.businessName,
        ),
      onSuccess: async () => {
        await updateApplicationStageMutate("income-details");
        handleCollectBusinessLocation();
      },
      onError: (errors) => {
        showError(errors?.response?.data?.message || errors.message);
      },
    });

  const handleSubmitIncomeDetails = () => {
    updateIncomeMutate();
  };

  const { mutate: updateBusinessMutate, isLoading: isLoadingBusiness } =
    useMutation({
      mutationKey: ["update borrower business"],
      mutationFn: () =>
        updateBorrowerBusinessDetails(
          borrower?.id,
          borrowerBusinessInfo.businessName,
          borrowerBusinessInfo.businessCounty,
          borrowerBusinessInfo.businessSubCounty,
          borrowerBusinessInfo.businessWard,
          borrowerBusinessInfo.businessVillage,
          borrowerBusinessInfo.businessLatitude,
          borrowerBusinessInfo.businessLongitude,
          borrowerBusinessInfo.businessPhysicalAddress,
          borrowerBusinessInfo.businessLocationDescription,
          borrowerBusinessInfo.businessImageUrl,
          borrowerBusinessInfo.businessPostalAddress,
        ),
      onSuccess: async () => {
        await updateApplicationStageMutate("business-location-details");
        handleCollectResidenceLocation();
      },
      onError: (errors) => {
        showError(errors?.response?.data?.message || errors.message);
      },
    });

  const handleSubmitBusinessInfo = () => {
    updateBusinessMutate();
  };

  const { mutate: updateResidenceMutate, isLoading: isLoadingResidence } =
    useMutation({
      mutationKey: ["update residence"],
      mutationFn: () =>
        updateBorrowerResidenceDetails(
          borrower?.id,
          borrowerResidenceInfo.residenceCounty,
          borrowerResidenceInfo.residenceSubCounty,
          borrowerResidenceInfo.residenceWard,
          borrowerResidenceInfo.residenceVillage,
          borrowerResidenceInfo.residenceLatitude,
          borrowerResidenceInfo.residenceLongitude,
          borrowerResidenceInfo.residencePhysicalAddress,
          borrowerResidenceInfo.residenceLocationDescription,
          borrowerResidenceInfo.residenceImageUrl,
        ),
      onSuccess: async () => {
        await updateApplicationStageMutate("residence-location-details");
        handleCollectChattels();
      },
      onError: (errors) => {
        showError(errors?.response?.data?.message || errors.message);
      },
    });

  const handleSubmitResidenceInfo = () => {
    updateResidenceMutate();
  };

  const { mutate: updateChattelMutate, isLoading: isLoadingChattel } =
    useMutation({
      mutationKey: ["update chattel"],
      mutationFn: () =>
        addBorrowerChattel(
          borrower?.id,
          borrowerChattel.name,
          borrowerChattel.location,
          borrowerChattel.value,
          borrowerChattel.fileUrl,
          borrowerChattel.description,
          borrowerChattel.condition,
          borrowerChattel.images,
        ),
      onSuccess: () => {
        setBorrowerChattel({
          name: "",
          location: "",
          value: 0,
          fileUrl: "",
          description: "",
          condition: "Good",
          images: null,
        });
        handleAddMyChattel();
      },
      onError: (errors) => {
        showError(errors?.response?.data?.message || errors.message);
      },
    });

  const handleSubmitChattelInfo = () => {
    updateChattelMutate();
  };

  const { mutate: addGuarantorMutate, isLoading: isLoadingGuarantor } =
    useMutation({
      mutationKey: ["add guarantor"],
      mutationFn: () =>
        createApplicationGuarantors(
          loanApplication?.id,
          guarantor.guarantorName,
          guarantor.guarantorPhone,
          guarantor.guarantorEmail,
          guarantor.residenceCounty,
          guarantor.residenceSubCounty,
          guarantor.residenceWard,
          guarantor.residenceVillage,
          guarantor.residenceLatitude,
          guarantor.residenceLongitude,
          guarantor.signatureUrl,
          guarantor.guaranteeAmount,
          guarantor.reason,
          guarantor?.guarantorPhoto,
          guarantor?.guarantorBusinessPhoto,
          guarantor?.residenceLocation,
        ),
      onSuccess: () => {
        setGuarantor({
          guarantorName: "",
          guarantorPhone: "",
          guarantorEmail: "",
          residenceCounty: "",
          residenceSubCounty: "",
          residenceWard: "",
          residenceVillage: "",
          residenceLatitude: "",
          residenceLongitude: "",
          signatureUrl: "",
          guaranteeAmount: "",
          status: "",
          reason: "",
          guarantorPhoto: "",
          guarantorBusinessPhoto: "",
        });
        handleAddMyGuarantor();
      },
      onError: (errors) => {
        showError(errors?.response?.data?.message || errors.message);
      },
    });

  const handleSubmitGuarantor = () => {
    addGuarantorMutate();
  };

  const {
    mutate: guarantorChattelMutate,
    isLoading: isLoadingGuarantorChattel,
  } = useMutation({
    mutationKey: ["update guarantor chattel"],
    mutationFn: () =>
      addGuarantorChattel(
        selectedGuarantor,
        guarantorChattel.name,
        guarantorChattel.location,
        guarantorChattel.value,
        guarantorChattel.fileUrl,
        guarantorChattel.description,
        guarantorChattel.condition,
        guarantorChattel.images,
      ),
    onSuccess: () => {
      setGuarantorChattel({
        name: "",
        location: "",
        value: 0,
        fileUrl: "",
        description: "",
        condition: "Good",
        images: null,
      });
      handleAddMyGuarantorChattel();
    },
    onError: (errors) => {
      showError(errors?.response?.data?.message || errors.message);
    },
  });

  const handleSubmitGuarantorChattel = () => {
    guarantorChattelMutate();
  };

  const {
    mutate: updateApplicationMutate,
    isLoading: isLoadingApplicationUpdate,
  } = useMutation({
    mutationKey: ["update loan application"],
    mutationFn: () => updateLoanApplication(loanApplication?.id, "pending"),
    onSuccess: () => {
      handleCompleteApplication();
      refetchLoanApplications();
    },
    onError: () => {
      displayDocumentFail();
    },
  });

  const handleFinalizeApplication = () => {
    updateApplicationMutate();
  };

  const {
    refetch: refetchLoanApplications,
    isRefetching,
    isLoading,
  } = useQuery({
    queryKey: [
      "loan-applications",
      page,
      limit,
      fromDate ? new Date(fromDate).toISOString() : null,
      toDate ? new Date(toDate).toISOString() : null,
      status,
      selectedLoanOfficer,
      selectedLoanProduct,
      minLoanAmount,
      maxLoanAmount,
    ],
    queryFn: async () => {
      const response = await getLoanApplications(
        page,
        limit,
        fromDate ? new Date(fromDate).toISOString() : null,
        toDate ? new Date(toDate).toISOString() : null,
        search,
        status,
        selectedLoanOfficer,
        selectedLoanProduct,
        minLoanAmount,
        maxLoanAmount,
      );
      return response.data.data;
    },
    onSuccess: (data) => {
      setLoanApplications(data.data);
      setPage(data.page);
      setTotalPages(data.pageCount);
      setLimit(data.limit);
      setTotalItems(data.total);
    },
  });

  const { data: statistics } = useQuery({
    queryKey: ["statistics"],
    queryFn: async () => {
      const response = await getLoanApplicationStatistics();
      return response.data.data;
    },
  });

  const getStatusIcon = (status) => {
    const s = status?.toLowerCase() || "";

    const statusMap = {
      incomplete: {
        color: "text-slate-500",
        bg: "bg-slate-50",
        borderColor: "border-slate-200",
        icon: <CircleDashed size={13} />,
        label: "Incomplete",
      },
      pending: {
        color: "text-orange-600",
        bg: "bg-orange-50",
        borderColor: "border-orange-100",
        icon: <Clock size={13} className="animate-pulse" />,
        label: "Pending",
      },
      "pending approval": {
        color: "text-amber-600",
        bg: "bg-amber-50",
        borderColor: "border-amber-100",
        icon: <FileSearch size={13} className="animate-pulse" />,
        label: "Pending Approval",
      },
      declined: {
        color: "text-rose-600",
        bg: "bg-rose-50",
        borderColor: "border-rose-100",
        icon: <XCircle size={13} />,
        label: "Declined",
      },
      approved: {
        color: "text-[#2A8C52]", // ZipGo Brand Green
        bg: "bg-green-50",
        borderColor: "border-green-100",
        icon: <CheckCircle2 size={13} />,
        label: "Approved",
      },
      disbursed: {
        color: "text-indigo-600",
        bg: "bg-indigo-50",
        borderColor: "border-indigo-200",
        icon: <Wallet size={13} />,
        label: "Disbursed",
      },
    };

    // Fallback for unknown statuses
    const config = statusMap[s] || {
      color: "text-gray-400",
      bg: "bg-gray-50",
      borderColor: "border-gray-100",
      icon: <HelpCircle size={13} />,
      label: status || "Unknown",
    };

    return (
      <div
        className={`
        inline-flex items-center gap-1.5 
        px-3 py-1 rounded-full 
        font-bold text-[10px] sm:text-[11px] 
        uppercase tracking-wider 
        border shadow-sm
        ${config.bg} ${config.color} ${config.borderColor}
      `}
      >
        <span className="flex-shrink-0">{config.icon}</span>
        <span className="whitespace-nowrap">{config.label}</span>
      </div>
    );
  };

  const toggleLoanAmount = () => {
    setOpenLoanAmount(true);
  };

  const closeLoanAmount = () => {
    setOpenLoanAmount(false);
  };

  const toggleBioInformation = () => {
    setOpenBioInformation(true);
  };

  const closeBioInformation = () => {
    setOpenBioInformation(false);
  };
  const togglePersonalInformation = () => {
    setOpenPersonalInformation(true);
  };

  const closePersonalInformation = () => {
    setOpenPersonalInformation(false);
  };
  const toggleKinInformation = () => {
    setOpenKinInformation(true);
  };

  const closeKinInformation = () => {
    setOpenKinInformation(false);
  };
  const toggleBusinessLocation = () => {
    setOpenBusinessLocation(true);
  };

  const closeBusinessLocation = () => {
    setOpenBusinessLocation(false);
  };
  const toggleResidenceLocation = () => {
    setOpenResidenceLocation(true);
  };

  const displayAddChattel = () => {
    setOpenAddChattel(true);
  };
  const closeAddChattel = () => {
    setOpenAddChattel(false);
  };
  const displayDocumentSuccess = () => {
    setOpenDocumentSuccess(true);
  };
  const closeDocumentSuccess = () => {
    setOpenDocumentSuccess(false);
  };
  const displayDocumentFail = () => {
    setOpenDocumentFail(true);
  };
  const closeDocumentFail = () => {
    setOpenDocumentFail(false);
  };
  const displayAddGuarantorChattel = () => {
    setOpenAddGuarantorChattel(true);
  };
  const closeAddGuarantorChattel = () => {
    setOpenAddGuarantorChattel(false);
  };

  const handleAddGuarantorChattel = (id) => {
    setSelectedGuarantor(id);
    displayAddGuarantorChattel();
  };

  const handleAddMyGuarantorChattel = () => {
    setModalKey((prev) => prev + 1);
    closeAddGuarantorChattel();
  };

  const displayAddGuarantor = () => {
    setOpenAddGuarantor(true);
  };
  const closeAddGuarantor = () => {
    setOpenAddGuarantor(false);
  };

  const handleAddGuarantor = () => {
    closeGuarantorInformation();
    displayAddGuarantor();
  };

  const handleAddMyGuarantor = () => {
    closeAddGuarantor();
    toggleGuarantorInformation();
  };

  const closeResidenceLocation = () => {
    setOpenResidenceLocation(false);
  };
  const toggleChattels = () => {
    setOpenChattels(true);
  };

  const closeChattels = () => {
    setOpenChattels(false);
  };
  const toggleFinish = () => {
    setOpenFinish(true);
  };

  const closeFinish = () => {
    setActiveIndex(0);
    setOpenFinish(false);
  };

  const handleFinish = async () => {
    setActiveIndex(9);
    await updateApplicationStageMutate("complete");
    closeGuarantorInformation();
    toggleFinish();
  };

  const handleCompleteLoanApplication = async () => {
    await updateApplicationStageMutate("documents");
    setActiveIndex(8);
    closeLoanDocuments();
    toggleGuarantorInformation();
  };

  const handleCompleteApplication = () => {
    setActiveIndex(0);
    closeFinish();
    displayDocumentSuccess();
  };

  const toggleGuarantorInformation = () => {
    setOpenGuarantorInformation(true);
  };

  const closeGuarantorInformation = () => {
    setOpenGuarantorInformation(false);
  };

  const collectGuarantorInformation = async () => {
    await updateApplicationStageMutate("chattel-details");
    setActiveIndex(7);
    closeChattels();
    toggleLoanDocuments();
  };

  const handleAddChattel = () => {
    closeChattels();
    displayAddChattel();
  };

  const handleAddMyChattel = () => {
    closeAddChattel();
    toggleChattels();
  };

  const handleCollectChattels = () => {
    setActiveIndex(6);
    closeResidenceLocation();
    toggleChattels();
  };

  const handleCollectResidenceLocation = () => {
    setActiveIndex(5);
    closeBusinessLocation();
    toggleResidenceLocation();
  };

  const handleCollectBusinessLocation = () => {
    setActiveIndex(3);
    closeIncomeInformation();
    toggleMpesaStatement();
  };

  const toggleIncomeInformation = () => {
    setOpenIncomeInformation(true);
  };

  const closeIncomeInformation = () => {
    setOpenIncomeInformation(false);
  };

  const handleCollectIncomeInformation = () => {
    setActiveIndex(3);
    closeKinInformation();
    toggleIncomeInformation();
  };

  const handleCollectLoanTypeInformation = () => {
    closeLoanAmount();
    togglePersonalInformation();
  };

  const handleCollectPersonalInformation = () => {
    setActiveIndex(2);
    closeBioInformation();
    toggleKinInformation();
  };

  const handleCollectKinInformation = () => {
    setActiveIndex(1);
    closePersonalInformation();
    toggleBioInformation();
  };

  const toggleOpenLoanFilter = () => {
    setOpenLoanFilter(true);
  };
  const closeOpenLoanFilter = () => {
    setOpenLoanFilter(false);
  };

  const handleApplyFilter = () => {
    closeOpenLoanFilter();
  };

  const [selectedLoans, setSelectedLoans] = useState([]);
  const isAllSelected =
    loanApplications?.length > 0 &&
    selectedLoans.length === loanApplications.length;

  const toggleSelectAll = () => {
    if (isAllSelected) {
      setSelectedLoans([]);
    } else {
      setSelectedLoans(loanApplications.map((loan) => loan.id));
    }
  };

  const toggleSelectOne = (id) => {
    if (selectedLoans.includes(id)) {
      setSelectedLoans(selectedLoans.filter((loanId) => loanId !== id));
    } else {
      setSelectedLoans([...selectedLoans, id]);
    }
  };

  const {
    mutate: exportAllLoanApplications,
    isLoading: loadingExportLoanApplications,
  } = useMutation({
    mutationKey: ["export all loan applications"],
    mutationFn: ({ format }) =>
      exportLoanApplications(
        format,
        fromDate,
        toDate,
        search,
        status,
        minLoanAmount,
        maxLoanAmount,
        selectedLoanProduct,
        selectedLoanOfficer,
      ),
    onSuccess: (blob, variables) => {
      downloadExportFile(blob, `Loans.${variables.format}`);
    },
    onError: (errors) => {
      showError(errors?.response?.data?.message || errors.message);
    },
  });

  const {
    mutate: exportSelectedLoanApplications,
    isLoading: loadingExportSelectedLoanApplications,
  } = useMutation({
    mutationKey: ["export all selected loan applications"],
    mutationFn: ({ format }) =>
      exportAllSelectedLoanApplications(format, selectedLoans),
    onSuccess: (blob, variables) => {
      downloadExportFile(blob, `Loans.${variables.format}`);
    },
    onError: (errors) => {
      showError(errors?.response?.data?.message || errors.message);
    },
  });

  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, totalItems);

  const appliedFiltersCount = [
    status,
    selectedLoanOfficer,
    selectedLoanProduct,
  ].filter(Boolean).length;

  return (
    <>
      {openPayslips && (
        <Payslips
          closePayslips={closePayslips}
          activeIndex={activeIndex}
          handleNextStep={handleAddPayslips}
          setPayslips={setPayslips}
          loading={loadingPayslips}
        />
      )}
      {openBankStatement && (
        <BankStatement
          closeBankStatement={closeBankStatement}
          activeIndex={activeIndex}
          handleNextStep={handleAddBankStatement}
          incomeDetails={incomeDetails}
          setIncomeDetails={setIncomeDetails}
          loading={loadingBankStatement}
        />
      )}
      {openMpesaStatement && (
        <MpesaStatement
          closeMpesaStatement={closeMpesaStatement}
          activeIndex={activeIndex}
          handleNextStep={handleUpdateMpesaStatement}
          incomeDetails={incomeDetails}
          setIncomeDetails={setIncomeDetails}
          loading={loadingMpesaStatement}
        />
      )}
      {openAddDocument && (
        <AddLoanDocument
          closeAddDocument={closeAddDocument}
          setLoanDocuments={setLoanDocuments}
          handleSubmitLoanDocument={handleSubmitLoanDocument}
          loadingLoanDocument={loadingLoanDocument}
        />
      )}
      {openLoanDocuments && (
        <LoanDocuments
          activeIndex={activeIndex}
          closeLoanDocuments={closeLoanDocuments}
          handleOpenAddDocument={handleOpenAddDocument}
          handleNextStep={handleCompleteLoanApplication}
          loading={false}
        />
      )}
      {openLoanFilter && (
        <Filter
          closeFilters={closeOpenLoanFilter}
          handleApplyFilter={handleApplyFilter}
          status={status}
          setStatus={setStatus}
          selectedLoanOfficer={selectedLoanOfficer}
          setSelectedLoanOfficer={setSelectedLoanOfficer}
          selectedLoanProduct={selectedLoanProduct}
          setSelectedLoanProduct={setSelectedLoanProduct}
          minLoanAmount={minLoanAmount}
          setMinLoanAmount={setMinLoanAmount}
          maxLoanAmount={maxLoanAmount}
          setMaxLoanAmount={setMaxLoanAmount}
          fromDate={fromDate}
          setFromDate={setFromDate}
          toDate={toDate}
          setToDate={setToDate}
        />
      )}
      {openLoanAmount && (
        <LoanAmount
          closeLoanAmount={closeLoanAmount}
          handleCollectLoanTypeInformation={handleCollectLoanTypeInformation}
          loanDetails={loanDetails}
          setLoanDetails={setLoanDetails}
        />
      )}
      {openBioInformation && (
        <BioInformation
          closeBioInformation={closeBioInformation}
          activeIndex={activeIndex}
          handleNextStep={handleSubmitBioInformation}
          selectedFrontIdFile={selectedFrontIdFile}
          setSelectedFrontIdFile={setSelectedFrontIdFile}
          selectedBackIdFile={selectedBackIdFile}
          setSelectedBackIdFile={setSelectedBackIdFile}
          idDetails={idDetails}
          setIdDetails={setIdDetails}
          loading={isLoadingBioInformation}
        />
      )}

      {openPersonalInformation && (
        <PersonalInformation
          closePersonalInformation={closePersonalInformation}
          activeIndex={activeIndex}
          handleNextStep={handleSubmitBorrowerInfo}
          borrowerInfo={borrowerInfo}
          setBorrowerInfo={setBorrowerInfo}
          errors={errors}
          loading={isLoadingBorrower}
        />
      )}

      {openKinInformation && (
        <NextOfKin
          closeKinInformation={closeKinInformation}
          activeIndex={activeIndex}
          handleNextStep={handleSubmitKinInformation}
          kinDetails={kinDetails}
          setKinDetails={setKinDetails}
          loading={isLoadingKin}
        />
      )}

      {openIncomeInformation && (
        <IncomeDetails
          closeIcomeInformation={closeIncomeInformation}
          activeIndex={activeIndex}
          handleNextStep={handleSubmitIncomeDetails}
          incomeDetails={incomeDetails}
          setIncomeDetails={setIncomeDetails}
          loading={isLoadingIncome}
        />
      )}

      {openBusinessLocation && (
        <BusinessLocation
          closeBusinessLocation={closeBusinessLocation}
          activeIndex={activeIndex}
          handleNextStep={handleSubmitBusinessInfo}
          borrowerBusinessInfo={borrowerBusinessInfo}
          setBorrowerBusinessInfo={setBorrowerBusinessInfo}
          loading={isLoadingBusiness}
        />
      )}

      {openResidenceLocation && (
        <ResidenceLocation
          closeResidenceLocation={closeResidenceLocation}
          activeIndex={activeIndex}
          handleNextStep={handleSubmitResidenceInfo}
          borrowerResidenceInfo={borrowerResidenceInfo}
          setBorrowerResidenceInfo={setBorrowerResidenceInfo}
          loading={isLoadingResidence}
        />
      )}

      {openChattels && (
        <BorrowerChattels
          closeChattels={closeChattels}
          activeIndex={activeIndex}
          handleNextStep={collectGuarantorInformation}
          handleAddChattel={handleAddChattel}
          loading={loadingApplicationStage}
        />
      )}

      {openAddChattel && (
        <AddChattel
          closeAddChattel={closeAddChattel}
          handleAddMyChattel={handleSubmitChattelInfo}
          borrowerChattel={borrowerChattel}
          setBorrowerChattel={setBorrowerChattel}
          loading={isLoadingChattel}
        />
      )}

      {openGuarantorInformation && (
        <Guarantors
          key={modalKey}
          closeGuarantorInformation={closeGuarantorInformation}
          activeIndex={activeIndex}
          handleNextStep={handleFinish}
          handleAddGuarantor={handleAddGuarantor}
          handleAddGuarantorChattel={handleAddGuarantorChattel}
          loading={loadingApplicationStage}
        />
      )}

      {openAddGuarantor && (
        <AddGuarantor
          closeAddGuarantor={closeAddGuarantor}
          handleAddMyGuarantor={handleSubmitGuarantor}
          guarantor={guarantor}
          setGuarantor={setGuarantor}
          loading={isLoadingGuarantor}
        />
      )}

      {openAddGuarantorChattel && (
        <AddGuarantorChattel
          closeAddGuarantorChattel={closeAddGuarantorChattel}
          handleAddMyGuarantorChattel={handleSubmitGuarantorChattel}
          guarantorChattel={guarantorChattel}
          setGuarantorChattel={setGuarantorChattel}
          loading={isLoadingGuarantorChattel}
        />
      )}

      {openFinish && (
        <Finish
          closeFinish={closeFinish}
          activeIndex={activeIndex}
          handleNextStep={handleFinalizeApplication}
          finishText="Send & Finish"
          loading={isLoadingApplicationUpdate}
        />
      )}

      {openDocumentSuccess && (
        <Success closeDocumentSuccess={closeDocumentSuccess} />
      )}

      {openDocumentFail && <Fail closeDocumentFail={closeDocumentFail} />}
      {isLoading ? (
        <LoanApplicationSkeleton />
      ) : (
        <div className="w-full pl-[10px]">
          <div className="flex items-center h-[60px] mb-[10px] justify-between">
            <div className="flex items-center gap-[5px]">
              <span className="font-bold text-[18px] text-[#000000]">
                Loan Applications
              </span>
            </div>
            <div className="flex items-center gap-[10px]">
              {hasPermission(
                auth?.roles,
                "c9a6fea5-ea4e-f042-1435-999df1545492",
              ) && (
                <button
                  onClick={toggleLoanAmount}
                  className="bg-[#000000] h-[40px] rounded-[30px] text-[#ffffff] text-[14px] font-normal px-[20px] flex items-center justify-center gap-[5px]"
                >
                  <Plus size={16} color="#ffffff" />
                  Create a New Loan Application
                </button>
              )}
            </div>
          </div>
          <div className="flex items-center mb-[20px] gap-[20px]">
            <LoanCard
              icon={<Sigma />}
              label="Total Loan Applications"
              value={statistics?.total ?? 0}
              increment="+0.00%"
              padColor="#4B5D67"
            />
            <LoanCard
              icon={<Circle color="#F5A623" />}
              label="Incomplete Applications"
              value={statistics?.incomplete ?? 0}
              increment="+0.00%"
              padColor="#F5A623"
            />
            <LoanCard
              icon={<Circle color="#00A676" />}
              label="Approved Applications"
              value={statistics?.approved ?? 0}
              increment="+0.00%"
              padColor="#00A676"
            />
            <LoanCard
              icon={<Clock color="#00319A" />}
              label="Pending Approval"
              value={statistics?.pendingApproval ?? 0}
              increment="+0.00%"
              padColor="#00319A"
            />
            <LoanCard
              icon={<Clock color="#000000" />}
              label="Rejected Applications"
              value={statistics?.declined ?? 0}
              increment="+0.00%"
              padColor="#000000"
            />
            <LoanCard
              icon={<Clock color="#000000" />}
              label="Disbursed Applications"
              value={statistics?.disbursed ?? 0}
              increment="+0.00%"
              padColor="#000000"
            />
          </div>
          <div className="h-[70px] w-full bg-white flex items-center justify-between px-[10px]">
            <button
              onClick={refetchLoanApplications}
              className="h-[35px] w-[120px] flex items-center justify-center gap-[5px] border border-[#00A676] bg-white rounded-[10px] text-[#00A676] font-medium text-[15px]"
            >
              {isRefetching ? <Loading /> : <Loader size={17} />}
              Update
            </button>
            <div className="h-[40px] w-[117px] text-[#5C5C5C] font-medium text-[15px] rounded-[10px] border border-[#F3F3F3] bg-white flex items-center justify-center">
              {selectedLoans?.length} Selected
            </div>
            <div
              onClick={toggleOpenLoanFilter}
              className="h-[40px] w-[127px] cursor-pointer text-[#5C5C5C] font-medium text-[15px] rounded-[10px] border border-[#F3F3F3] bg-[#FBF5F5] flex items-center justify-center gap-[5px]"
            >
              <SortAsc color="#000000" />
              <span className="text-[#000000]">Filter</span>
              <span className="text-[#000000]">{appliedFiltersCount}</span>
            </div>
            <div className="flex items-center border border-gray-300 rounded-md px-2 h-[40px] w-[50%] bg-white">
              <Search className="text-gray-500 w-5 h-5 mr-2" />
              <input
                type="text"
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search loans, name, loan code..."
                className="w-full outline-none text-sm text-gray-700 placeholder-gray-400 bg-transparent"
              />
              <button
                onClick={refetchLoanApplications}
                className="ml-2 p-2 bg-blue-600 rounded-md hover:bg-blue-700"
              >
                <Search className="w-4 h-4 text-white" />
              </button>
            </div>
            <p className="text-[#000000] truncate text-[15px] font-normal">
              {loanApplications?.length} Results
            </p>
            {hasPermission(
              auth?.roles,
              "cf24d3c1-6088-3aaa-f236-59e1eaac7f4c",
            ) &&
              (selectedLoans?.length === 0 ? (
                <Dropdown
                  menu={{ items }}
                  trigger={["click"]}
                  placement="bottom"
                >
                  <Button className="flex items-center bg-[#F3F3F3] border-[0.7px] border-[#A8A8A8] h-[40px] rounded-[30px] px-[20px] justify-center gap-[5px] text-[16px] text-[#5C5C5C]">
                    {loadingExportLoanApplications ? (
                      <Loading />
                    ) : (
                      <LucideUpload size={17} />
                    )}
                    <span>Export</span>
                  </Button>
                </Dropdown>
              ) : (
                <Dropdown
                  menu={{ items: selectedItems }}
                  trigger={["click"]}
                  placement="bottom"
                >
                  <Button className="flex items-center bg-[#F3F3F3] border-[0.7px] border-[#A8A8A8] h-[40px] rounded-[30px] px-[20px] justify-center gap-[5px] text-[16px] text-[#5C5C5C]">
                    {loadingExportSelectedLoanApplications ? (
                      <Loading />
                    ) : (
                      <LucideUpload size={17} />
                    )}
                    <span>Export</span>
                  </Button>
                </Dropdown>
              ))}
          </div>
          <div>
            <div className="h-[44px] px-[10px] w-full bg-[#F3F3F3] mb-[10px] flex items-center">
              <div className="w-[3%]">
                <input
                  type="checkbox"
                  name="loan"
                  id="loan"
                  checked={isAllSelected}
                  onChange={toggleSelectAll}
                />
              </div>
              <div className="w-[10%] text-[#000] font-bold text-[14px]">
                ID
              </div>
              <div className="w-[12%] text-[#000] truncate font-bold text-[14px]">
                BORROWER’S NAME
              </div>
              <div className="w-[13%] text-[#000] px-[10px] font-bold text-[14px]">
                PRODUCT TYPE
              </div>
              <div className="w-[10%] text-[#000] font-bold text-[14px]">
                PERIOD (MONTHS)
              </div>
              <div className="w-[10%] text-[#000] font-bold text-[14px]">
                INTEREST RATE
              </div>
              <div className="w-[10%] text-[#000] font-bold text-[14px]">
                LOAN AMOUNT
              </div>
              <div className="w-[10%] text-[#000] truncate font-bold text-[14px]">
                POTENTIAL REPAYMENT
              </div>
              <div className="w-[10%] text-[#000] font-bold text-[14px]">
                DATE CREATED
              </div>
              <div className="w-[12%] text-[#000] font-bold text-[14px]">
                STATUS
              </div>
            </div>
            {loanApplications?.length > 0 ? (
              loanApplications?.map((loan, index) => (
                <div
                  key={index}
                  className="h-[40px] px-[10px] w-full bg-[#FFFFFF] mb-[7px] flex items-center"
                >
                  <div className="w-[3%]">
                    <input
                      type="checkbox"
                      name="loan"
                      checked={selectedLoans.includes(loan.id)}
                      onChange={() => toggleSelectOne(loan.id)}
                    />
                  </div>
                  <div
                    onClick={() =>
                      navigate(`/dashboard/loan-application/${loan?.id}`)
                    }
                    className="w-[10%] cursor-pointer truncate text-[#2A8C52] font-normal text-[13px]"
                  >
                    {loan?.loanCode?.slice(0, 10)}
                  </div>
                  <div className="w-[12%] truncate text-[#000] font-normal text-[13px]">
                    {loan?.customer?.firstname || loan?.customer?.lastname
                      ? `${loan?.customer?.firstname ?? ""} ${
                          loan?.customer?.lastname ?? ""
                        }`.trim()
                      : loan?.customer?.username || "N/A"}
                  </div>
                  <div className="w-[13%] px-[10px] text-[#000] font-normal text-[13px] truncate">
                    {loan?.product?.name}
                  </div>
                  <div className="w-[10%] text-[#000] font-normal text-[13px] truncate">
                    {loan?.loanPeriod} months
                  </div>
                  <div className="w-[10%] text-[#000] font-normal text-[13px] truncate">
                    {loan?.interestRate}
                  </div>
                  <div className="w-[10%] text-[#000] font-normal text-[13px] truncate">
                    {formatAmount(loan?.loanAmount)}
                  </div>
                  <div className="w-[10%] text-[#000] font-normal text-[13px] truncate">
                    {formatAmount(loan?.repaymentAmount)}
                  </div>
                  <div className="w-[10%] text-[#000] font-normal text-[13px] truncate">
                    {formattedDate(loan?.createdAt)}
                  </div>
                  <div className="w-[12%] text-[#000] font-normal text-[13px] flex items-center gap-2 truncate">
                    {getStatusIcon(loan?.status)}
                  </div>
                </div>
              ))
            ) : (
              <div className="flex flex-col items-center justify-center py-28 px-6 text-center bg-white border-1 border-gray-100 mt-4">
                {/* Visual Icon Container */}
                <div className="relative mb-8">
                  {/* Soft Glow Background */}
                  <div className="absolute inset-0 bg-green-100 blur-3xl rounded-full opacity-40 scale-150" />

                  <div className="relative w-24 h-24 bg-white rounded-2xl flex items-center justify-center border border-gray-100 shadow-xl shadow-gray-200/50">
                    <Landmark size={40} className="text-[#2A8C52]" />
                    {/* Small floating badge icon */}
                    <div className="absolute -top-2 -right-2 w-8 h-8 bg-[#2A8C52] rounded-full flex items-center justify-center border-4 border-white shadow-sm">
                      <Plus size={16} className="text-white" />
                    </div>
                  </div>
                </div>

                {/* Text Content */}
                <div className="max-w-sm">
                  <h3 className="text-gray-900 font-bold text-2xl tracking-tight">
                    No Loan Applications
                  </h3>
                  <p className="text-gray-500 mt-3 text-[15px] leading-relaxed">
                    It looks like there are no active or pending loan
                    applications in this category. You can start a new request
                    or check your filters.
                  </p>
                </div>

                {/* Action Buttons */}
                <div className="mt-10 flex flex-col sm:flex-row items-center gap-4">
                  <button
                    onClick={() => {
                      /* Navigate to new loan form */
                    }}
                    className="w-full sm:w-auto px-8 py-3 bg-[#2A8C52] text-white text-sm font-bold rounded-2xl hover:bg-[#227042] hover:shadow-xl hover:shadow-green-900/20 transition-all flex items-center justify-center gap-2 group"
                  >
                    <FilePlus
                      size={18}
                      className="group-hover:scale-110 transition-transform"
                    />
                    Create New Loan
                  </button>

                  <button
                    onClick={() => {
                      /* Clear Filters */
                    }}
                    className="w-full sm:w-auto px-8 py-3 bg-white text-gray-600 text-sm font-bold rounded-2xl border border-gray-200 hover:bg-gray-50 transition-all flex items-center justify-center gap-2"
                  >
                    <Search size={18} />
                    View All Records
                  </button>
                </div>
              </div>
            )}
          </div>
          <div className="h-[50px] mb-[20px] flex items-center justify-between">
            <div className="flex items-center gap-[10px]">
              <p className="text-[15px] text-[#5C5C5C] font-normal">
                {start}–{end} of {totalItems}
              </p>
              <p className="text-[15px] text-[#5C5C5C] font-normal">
                Row/Page:
              </p>
              <p className="text-[15px] text-[#5C5C5C] font-normal">
                {page}/{totalPages}
              </p>
              <select
                className="h-[35px] w-[100px] px-[10px] text-[12px]"
                name="row"
                id="row"
                value={limit}
                onChange={(e) => setLimit(e.target.value)}
              >
                <option value="10">10 items</option>
                <option value="20">20 items</option>
                <option value="25">25 items</option>
              </select>
            </div>
            <div>
              <Pagination
                currentPage={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LoanApplications;
